// rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';
import listingsReducer from './slices/listings';
import authReducer from './slices/auth';
import showingsReducer from './slices/showings';
import messagesReducer from './slices/messages';
import notificationsReducer from './slices/notifications';
import offersReducer from './slices/offers';
import transactionsReducer from './slices/transactions';
import statusReducer from './slices/status';
import uploadsReducer from './slices/uploads';
import inspectionsReducer from './slices/inspections';
import budgetReducer from './slices/budget';
import prepProgressReducer from './slices/prepProgress';
import demoReducer from './slices/demo';
import buyerPreferencesReducer from './slices/buyerPreferences';
import buyerPropertyMatchesReducer from './slices/buyerPropertyMatches';
import buyerOffMarketMatchesReducer from './slices/buyerOffMarketMatches';
import buyerBudgetsReducer from './slices/buyerBudgets';

const rootReducer = combineReducers({
  listings: listingsReducer,
  auth: authReducer,
  showings: showingsReducer,
  messages: messagesReducer,
  offers: offersReducer,
  notifications: notificationsReducer,
  transactions: transactionsReducer,
  status: statusReducer,
  inspections: inspectionsReducer,
  uploads: uploadsReducer,
  budget: budgetReducer,
  prepProgress: prepProgressReducer,
  demo: demoReducer,
  buyerPreferences: buyerPreferencesReducer,
  buyerPropertyMatches: buyerPropertyMatchesReducer,
  buyerOffMarketMatches: buyerOffMarketMatchesReducer,
  buyerBudgets: buyerBudgetsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
